import { LocationList } from '@libs/models/locations';
import { filterToQueryParams } from '../utils';
import { request } from '../request';
import { FiltersCollection } from '@libs/store/filters';

export type GetLocationsParams = {
  orderBy?: { key: string; sort: string }[];
  search?: string;
  page?: number;
  size?: number;
  filters?: FiltersCollection;
};
export function getLocations(params?: GetLocationsParams) {
  const filters = filterToQueryParams(params?.filters ?? {});
  return request.get<LocationResponse>('/v2/settings/locations', {
    params: {
      pageNumber: params?.page,
      pageSize: params?.size,
      orderBy_in: params?.orderBy?.map((p) => {
        return `${p.key}_${p.sort}`;
      }),
      search: params?.search,
      ...filters,
    },
  });
}
type LocationResponse = {
  data: LocationList[];
  total: number;
};
